import { Platform } from "models/platform";
import axiosClient from "./axiosClient";
import { ApiResponse, ImageUrlData, RemovePayload } from "models";

import { PlatformSubmitForm, PlatformPayload } from "models/platform";

const platformApi = {
  getPlatformList(data: PlatformPayload): Promise<Platform> {
    const url = `/store/getStorePlatform?page=${data.page || ""}&limit=${
      data.limit || ""
    }&search=${data.search || ""}&sortField=${data.sortName || ""}&sortType=${
      data.sortType || ""
    }
    `;
    return axiosClient.get(url);
  },

  getPlatformById(data: PlatformPayload): Promise<Platform> {
    const url = `/store/getStorePlatform?_id=${
      data?.id || ""
    }disablePagination=true
    `;
    return axiosClient.get(url);
  },

  addPlatform(data: Platform): Promise<ApiResponse> {
    const url = `/store/addStorePlatform`;
    return axiosClient.post(url, data);
  },

  updatePlatform(data: PlatformSubmitForm): Promise<ApiResponse> {
    const url = `/store/addStorePlatform`;
    return axiosClient.post(url, {
      id: data.platformId,
      platformName: data.platformName,
      slug: data.slug,
      width: data.width,
      height: data.height,
      photoURL: data.logo,
      Active: data.Active,
    });
  },

  deletePlatform(data: RemovePayload): Promise<ApiResponse> {
    const url = `/store/deleteStorePlatform?id=${data._id}`;
    return axiosClient.delete(url);
  },

  getImageUrl(data: ImageUrlData): Promise<ApiResponse> {
    const url = `/settings/uploadImage`;
    return axiosClient.post(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
};

export default platformApi;
